import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { RoleEditSchema } from "../../../ValidationSchema";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


const CmsEdit = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  const GetUserData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/product/edit-get?id=${location?.state?.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setInitialValues({
            name: res?.data?.data?.name,
          });
        }
      })
      .catch((err) => {

        const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
        const STATUS = [401, 403];
        if (
          STATUS.includes(err.response.status) ||
          MSG.includes(err.response.data.msg)
        ) {
          localStorage.clear();
          Navigate("/admin/login");
        } else {
          toast.error(err?.response?.data?.msg);
        }
      });
  };

  const EditCMS = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: RoleEditSchema,

    onSubmit: (values, action) => {
      let data = {
        id: location?.state?.id,
        name: values.name,
      };
      axios
        .post(`${process.env.REACT_APP_URL}/admin/product/store`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`Role Updated Successfully`);
            Navigate("/admin/role", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    GetUserData();
  }, []);

 return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Edit CMS</h1>
          <p className="al-sub">Update this CMS entry.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={EditCMS.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg></div>
            <h3 className="al-cardhead__title">CMS Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Key</label>
              <input className="al-input" type="text" placeholder="Enter Key"
                value={EditCMS.values.key} onChange={EditCMS.handleChange} onBlur={EditCMS.handleBlur} name="key" />
              {EditCMS.errors.key && EditCMS.touched.key ? (
                <div className="al-err">{EditCMS.errors.key}</div>
              ) : null}
            </div>

            <div className="al-form__full">
              <label className="al-label">Description</label>
              <CKEditor
                editor={ClassicEditor}
                data={EditCMS.values.description}
                className="custom-ckeditor"
                onChange={(event, editor) => {
                  const data = editor.getData();
                  EditCMS.setFieldValue("description", data);
                }}
                onBlur={() => EditCMS.setFieldTouched("description", true)}
              />
              {EditCMS.errors.description && EditCMS.touched.description && (
                <div className="al-err">{EditCMS.errors.description}</div>
              )}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CmsEdit;
